import { Link } from "@tanstack/react-router";
import logoLight from "@/assets/viny-logo-white-2026.svg.asset.json";
import logoDark from "@/assets/viny-logo-black-2026.svg.asset.json";

// Wordmark aspect ratio (matches source artwork 2742x985)
const ASPECT = 2742 / 985;

export function Logo({
  className = "",
  withLink = true,
  variant = "dark",
  size = 36,
  to = "/",
}: {
  className?: string;
  withLink?: boolean;
  /** "dark" = dark mark (use on light bg), "light" = light mark (use on dark bg) */
  variant?: "light" | "dark";
  /** Height in px; width is derived from the wordmark aspect ratio. */
  size?: number;
  to?: string;
}) {
  const src = variant === "dark" ? logoDark.url : logoLight.url;
  const height = size;
  const width = Math.round(size * ASPECT);
  const img = (
    <img
      src={src}
      alt="Viny Club"
      width={width}
      height={height}
      className={`object-contain ${className}`}
      style={{ width, height }}
    />
  );
  if (!withLink) return img;
  return (
    <Link to={to} className="inline-flex items-center" aria-label="Viny Club home">
      {img}
    </Link>
  );
}
